import React, {Component, PropTypes} from 'react';
import {Button} from 'react-bootstrap';
import moment from 'moment';

import ReactTable from 'react-table';

export default class CandidatesList extends Component {
  static propTypes = {
    vacancies: PropTypes.array
  };

  constructor(props) {
    super(props);

    this.state = { selected: {}, selectAll: 0 };

    this.toggleRow = this.toggleRow.bind(this);
  }

  toggleRow(id) {
    console.log('toggling row');
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[id] = !this.state.selected[id];
    this.setState({
      selected: newSelected,
      selectAll: 2
    });

    this.props.select(newSelected);
  }

  toggleSelectAll() {
    let newSelected = {};

    if (this.state.selectAll === 0) {
      this.state.vacanciesIndexed.forEach(x => {
        newSelected[x.id] = true;
      });
    }

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    });

    this.props.select(newSelected);
  }

  render() {
    const {isUpdating, all:vacancies, selectOne} = this.props;
    const columns = [
      {
        Header: '#',
        filterable: false,
        accessor: 'index',
        Cell: props => props.value+'.',
        maxWidth: 35
      },
      {
        id: "checkbox",
        accessor: "",
        Cell: ({ original }) => {
          return (
            <input
              original={original}
              type="checkbox"
              className="checkbox"
              checked={this.state.selected[original._id] === true}
              onChange={() => this.toggleRow(original._id)}
            />
          );
        },
        Header: x => {
          return (
            <input
              type="checkbox"
              className="checkbox"
              checked={this.state.selectAll === 1}
              ref={input => {
                if (input) {
                  input.indeterminate = this.state.selectAll === 2;
                }
              }}
              onChange={() => this.toggleSelectAll()}
            />
          );
        },
        sortable: false,
        width: 45

      },
      {
        Header: 'Title',
        accessor: 'title',
      },
      {
        id: 'companyName', // Required because our accessor is not a string
        Header: 'Company Name',
        accessor: 'company.brief.name',
      },
      {
        Header: 'Location',
        accessor: 'location'
      },
      {
        Header: 'Status',
        accessor: 'status'
      },
      {
        id: 'actions',
        Header: 'Actions',
        sortable: false,
        filterable: false,
        accessor: item => (
          <Button onClick={selectOne(item._id)}>
            View Details
          </Button>
        )
      }
    ];

    const vacanciesIndexed = vacancies && vacancies.map((el,index) => ({index:index+1, ...el})) //immutable

    return <ReactTable
      loading={isUpdating || !vacancies }
      data={vacanciesIndexed}
      columns={columns}
      filterable />;
  }
}



// WEBPACK FOOTER //
// ./src/components/vacancies/DataGrid.jsx